import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../common/breadcrumb";
import ShiftReportFilters from "./shiftReportFilters";
import ShiftReportBody from "./shiftReportBody";
import LoadingIndicator from "../../../common/loadingIndicator";
import apiClient from "../../../../utils/apiClient";
import { isEmpty } from "lodash";

/**
 * ShiftReport Component
 * @returns {JSX.Element}
 * @constructor
 */
export default function ShiftReport(props) {
    const {id, type, date_from, date_to} = props.match.params;
    const [data, setData] = useState(null);
    const [filters, setFilters] = useState({
        financial_period_id: "",
        pay_period_id: "",
        isLoading: false,
        isSubmitted: false,
    });

    const reportFilterProps = {
        setFilters,
        setData,
    };

    const reportBodyProps = {
        filters,
        data,
    };

    useEffect(()=> {
        if (id) {
            apiClient
                .post("getShiftReportDataNew", {financial_period_id: type === 'financial_period' ? id : '', pay_period_id: type === 'pay_period' ? id : ''})
                .then((response) => {
                    if (isEmpty(response.data)) {
                        setData(null);
                        return;
                    }
                    setData(response.data);
                })
                .then(setFilters(prev=>({
                    ...prev,
                    financial_period_id: type === 'financial_period' ? id : '',
                    pay_period_id: type === 'pay_period' ? id : '',
                    isSubmitted: true
                })))
        }
            
    }, [id, type])

    return (
        <>
            <Breadcrumb title="Shift Report" parent="Reports" />
            {id ? <h3>{type === 'financial_period' ? 'Monthly Data Period' : 'Weekly Data Period'} ({date_from} - {date_to})</h3> : <ShiftReportFilters {...reportFilterProps} />}
            <ShiftReportBody {...reportBodyProps} />
            <LoadingIndicator isLoading={filters.isLoading} />
        </>
    );
}
